import { createSlice } from '@reduxjs/toolkit';

export interface IColumnFilterConfig {
  orderColumnFilter: string[];
  transactionColumnFilter: string[];
  subscriptionColumnFilter: string[];
  customerColumnFilter: string[];
}

const initialState: IColumnFilterConfig = {
  orderColumnFilter: [],
  transactionColumnFilter: [],
  subscriptionColumnFilter: [],
  customerColumnFilter: [],
};

export const ColumnFilterSlice = createSlice({
  name: 'columnFilterSlice',
  initialState,
  reducers: {
    setMyColumnDetails: (state, action) => {
      return {
        ...state,
        ...action.payload,
      };
    },
    clearColumnDetails: () => initialState,
  },
});

export const { setMyColumnDetails, clearColumnDetails } =
  ColumnFilterSlice.actions;

export default ColumnFilterSlice.reducer;
